module.exports = __webpack_public_path__ + "img/NLYLOGO.b43761e2.png";